import React from "react";
import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] },
  }),
};

export function Reveal({ children, i = 0, className = "" }) {
  return (
    <motion.div
      variants={reveal}
      custom={i}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Section({ children, id, className = "", testid }) {
  return (
    <section
      id={id}
      data-testid={testid}
      className={`relative py-16 md:py-32 ${className}`}
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">{children}</div>
    </section>
  );
}

export function PageHeader({ overline, title, lede, image, alt }) {
  return (
    <section className="relative pt-10 md:pt-24 pb-12 md:pb-24 border-b border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7 lg:col-span-8">
          {overline && <p className="overline mb-4 md:mb-6" data-testid="page-overline">{overline}</p>}
          <h1
            data-testid="page-title"
            className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tightest text-bone-50 max-w-4xl"
          >
            {title}
          </h1>
          {lede && (
            <p className="mt-6 md:mt-10 text-bone-300 text-base md:text-xl leading-relaxed max-w-2xl">
              {lede}
            </p>
          )}
        </div>
        {image && (
          <div className="col-span-12 md:col-span-5 lg:col-span-4 mt-6 md:mt-0">
            <div className="relative aspect-[4/5] w-full overflow-hidden border border-white/10 rounded-sm">
              <img
                src={image}
                alt={alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/20" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
